const API_KEY = process.env.REACT_APP_API_KEY;
const API_URL = 'https://api.siliconflow.cn/chat/completions';

export const sendMessage = async (messages, onProgress) => {
  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${API_KEY}`
      },
      body: JSON.stringify({
        model: "deepseek-ai/DeepSeek-V2.5",
        messages: [
          { 
            role: "system", 
            content: `请遵循以下规则回复：
            1. 使用 markdown 格式
            2. 重要内容使用标题区分
            3. 代码要放在代码块中
            4. 关键信息用加粗或列表呈现
            5. 如果有步骤说明，使用有序列表
            6. 重要警告或提示使用引用块`
          },
          ...messages
        ],
        temperature: 0.5,
        max_tokens: 2048,
        stream: true
      })
    });

    const reader = response.body.getReader();
    let partialResponse = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = new TextDecoder().decode(value);
      const lines = chunk.split('\n');

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const trimmedLine = line.slice(6);
          if (trimmedLine === '[DONE]') continue;
          
          try {
            const data = JSON.parse(trimmedLine);
            if (data.choices[0].delta && data.choices[0].delta.content) {
              partialResponse += data.choices[0].delta.content;
              onProgress({
                role: 'assistant',
                content: partialResponse
              });
            }
          } catch (e) {
            // 忽略无效的 JSON 数据
            continue;
          }
        }
      }
    }

    return {
      role: 'assistant',
      content: partialResponse
    };
  } catch (error) {
    console.error('API调用错误:', error);
    throw error;
  }
}; 